/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getInvitePreviewV1ResponseDataSchema = z.object({
  nickname: z.string().nullable(),
  primaryLanguage: z.string().nullable(),
});

export type IGetInvitePreviewV1ResponseData = z.infer<typeof getInvitePreviewV1ResponseDataSchema>;

export const getInvitePreviewV1ResponseSchema = createApiResponseSchema(
  getInvitePreviewV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetInvitePreviewV1ResponseData>>;

export type IGetInvitePreviewV1Response = IAPI<IGetInvitePreviewV1ResponseData>;
